import { createAction } from '@reduxjs/toolkit';

export const setPayrollProvider = createAction<string>(
    'store/PAYROLL_PROVIDER::SET',
);

export const analyticsOrganicSignupPaychexTest = createAction<string>(
    'ANALYTICS::ORGANIC_SIGNUP_PAYCHEX_TEST',
);

export const analyticsPaychexIntroScreenViewed = createAction(
    'ANALYTICS::PAYCHEX_INTRO_SCREEN_VIEWED',
);

export const analyticsPaychexSSOIntroClickLogin = createAction(
    'ANALYTICS::PAYCHEX_SSO_INTRO_CLICK_LOGIN',
);

export const analyticsPaychexSSOIntroClickSkip = createAction(
    'ANALYTICS::PAYCHEX_SSO_INTRO_CLICK_SKIP',
);
